import { WalletState } from "../../../store";

export const getPassengersState = (state: WalletState) => state.passengers;

export const getPassengers = (state: WalletState) =>
  getPassengersState(state).passengers;

export const getPassengersCallState = (state: WalletState) =>
  getPassengersState(state).passengersCallState;
